class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const addedItems = parsedState.items;
    this.productId = parsedState.id || addedItems?.[0]?.id;

    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const sectionHtml = parsedState.sections[section.id];
        if (!sectionHtml) return;

        const el = document.getElementById(section.id);
        if (!el) return;

        if (addedItems && section.id === 'cart-notification-product') {
          el.innerHTML = this.buildMultiItemHtml(sectionHtml, addedItems);
        } else {
          el.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        }
      });
    }

    const cartItemsNumbers = document.getElementById('item_count_js');
    if (cartItemsNumbers) {
      const quantity = addedItems
        ? addedItems.reduce((sum, item) => sum + item.quantity, 0)
        : parsedState.quantity;
      cartItemsNumbers.innerHTML = quantity > 99 ? '#' : quantity;
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  buildMultiItemHtml(sectionHtml, items) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    return items
      .map((item) => {
        const itemEl = doc.querySelector(`#cart-notification-product-${item.id}`);
        return itemEl ? itemEl.outerHTML : '';
      })
      .join('');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
